import React from 'react';
import { DialogContent } from '@material-ui/core';
import '../styles.css';
import FileViewer from 'react-file-viewer';

const CustomErrorComponent = ({ error }) => (
	<div style={{ color: 'red' }}>
		Error while loading the file: {error.message}
	</div>
);

const DocumentViewer = ({ url }) =>
{

	const onError = (e) =>
	{
		console.error('Error in file viewer:', e);
		// You can handle the error here, e.g., log it or show a message to the user
	};

	return (
		<div className='flexCol FileWidth80 mrgnHAuto alignCntr fullH'>
			<div className='flexRow  justifyCntr fullH'>
				<DialogContent>
					<FileViewer
						fileType='pdf'
						filePath={url}
						errorComponent={CustomErrorComponent}
						onError={onError}
					/>

				</DialogContent>
			</div>
		</div>
	);
};

export default React.memo(DocumentViewer);